export default __webpack_public_path__ + "static/media/tip14.2362fabf.png";